import { FieldNames } from '../Interfaces/Auth';

export const labelsForm = {
  [FieldNames.Email]: 'Email',
  [FieldNames.Password]: 'Password',
  [FieldNames.Password2]: 'Password Repeat',
};

export const placeholdersForm = {
  [FieldNames.Email]: 'Your email',
  [FieldNames.Password]: 'Your password',
  [FieldNames.Password2]: 'Repeat your password',
};

// Default width for module
export const WIDTH_MODULE = '360px';
